module.exports = __webpack_public_path__ + "static/media/valueAddedServicesNew.30626679.svg";